import { ContentPlaceholderUI } from "./ContentPlaceholderUI";
import { StandardProps } from "../componentMap";

export function ContentPlaceholder({
  configProps,
}: Pick<StandardProps, "configProps">) {
  const placeholderId = configProps?.placeholderId
    ? String(configProps.placeholderId)
    : "";

  if (!placeholderId) return null;

  return <ContentPlaceholderUI placeholderId={placeholderId} />;
}
